import { request } from "./authApi";

// Public: matches the backend's Section A /featured-topics route. Returns
// up to 3 entries ({ position, topic_id, issue_id, ..., category, title,
// description, byline, image_path }), one per homepage hero-poster slot
// an admin has picked a card for.
export function getFeaturedTopics() {
  return request("/featured-topics");
}

// Admin only (Section C). position is 1, 2, or 3.
export function setFeaturedTopic(token, position, issueTopicId) {
  return request(`/featured-topics/${position}`, {
    method: "PUT",
    body: { issue_topic_id: issueTopicId },
    token,
  });
}

export function clearFeaturedTopic(token, position) {
  return request(`/featured-topics/${position}`, { method: "DELETE", token });
}
